import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    margin: 'auto'
  },
  content: {
    width: 'auto',
    padding: [[theme.spacing.unit * 2, theme.spacing.unit * 2, 0]],
    marginLeft: 0,
    marginRight: 0,
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      padding: [[theme.spacing.unit * 3, theme.spacing.unit * 3, 0]]
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      padding: [[theme.spacing.unit * 6, theme.spacing.unit * 4, 0]]
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      marginLeft: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2
    },
    [theme.breakpoints.up(
      theme.breakpoints.values.lg +
        theme.spacing.unit * 2 * 2 +
        theme.drawerOpenWidth
    )]: {
      width: theme.breakpoints.values.lg,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '& header:first-of-type': {
      padding: [[5, 0]]
    }
  }
}));

export default function Content(props) {
  const classes = useStyles();
  const { children, isPaper = true } = props;

  return (
    <div className={classes.content}>
      {isPaper ? <Paper className={classes.paper}>{children}</Paper> : children}
    </div>
  );
}
